<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<ng-container *ngIf="!hideApplyAndCancelButtons">
  <div>
    <button class="btn btn-sm btn-primary" (click)="onApply()">
	  <i class="zmdi zmdi-check"></i>
    </button>
    <button class="btn btn-sm btn-danger" (click)="onCancel()">
	  <i class="zmdi zmdi-close"></i>
    </button>
  </div>
</ng-container>
<div>
  <div ng2FileDrop class="dropzone" [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }" (fileOver)="fileOverBase($event)" [uploader]="uploader">
    <div *blockUI="'file-uploader'" class="text-wrapper centered">
      <input *ngIf="singleFile" type="file" name="file" id="file" class="inputfile" ng2FileSelect [uploader]="uploader" (change)="onChange($event)" />
      <input *ngIf="!singleFile" multiple type="file" name="file" id="file" class="inputfile" ng2FileSelect [uploader]="uploader" />
      <label for="file">Choose A File</label>
      <div>
        <label>Or</label>
      </div>
      <div class='flex-layout-row flex-layout-align-center-center flex-layout-gap-10px'>
        <div>Drop Your File{{ singleFile ? '' : '(s)' }} here</div>
        <div *ngIf="filesToUpload > 0">or</div>
        <div *ngIf="filesToUpload > 0"><button mat-raised-button (click)="clearQueue()">Remove Files</button></div>
      </div>
      <div class="centered">
        <i class="fa fa-upload fa-3x"></i>
      </div>
      <div *ngIf="filesToUpload > 0" class="centered">
        {{ filesToUpload }} file{{ singleFile ? '' : '(s)' }} ready for uploading...
		<div *ngFor="let thisfile of this.uploader.queue" class="mr-1"><i class="zmdi zmdi-file"></i> {{ thisfile?.file?.name }}</div>
      </div>
      <div></div>
    </div>
  </div>
  <div *ngIf="uploading">
    Progress {{ uploadProgress }}
    <p>
      <mat-progress-bar color="primary" mode="determinate" [value]="uploadProgress"> </mat-progress-bar>
    </p>
  </div>
</div>
